export default {
    removeDuplicates: <T, K extends keyof T>(items: T[], key: K): T[] => {
        const seenItems = new Set<T[K]>()
        return items.filter(item => {
            const duplicate = seenItems.has(item[key])
            seenItems.add(item[key])
            return !duplicate
        })
    }
}